var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "料金計算", visible: _vm.dialogVisible, width: "45em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("CalculationForm", {
              ref: "calculationForm",
              attrs: {
                action: "/calculation-fees-for-security",
                billingYmMode: "this"
              },
              model: {
                value: _vm.calculationFormModel,
                callback: function($$v) {
                  _vm.calculationFormModel = $$v
                },
                expression: "calculationFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("CalculationDialogFooter", {
              on: { calculation: _vm.clickCalculation }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }